import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { Api } from '@.api';
import { Layout } from '@.layout';
import { Table2 } from '@.partials';
import { Button, Filter3 } from '@.ui';
import { LinkHelper } from '@/Services';
import { useModalTableConfirm } from '@/Shared/lib/useModalTableConfirm';
import { Request } from '@/Types';
import { ParentCompanyResource } from '@/Types/ParentCompany';

export const ParentCompaniesAllPage = () => {
    const navigator = useNavigate();

    const get = useCallback((q: Request.All) => {
        return Api.parentCompany().list(q);
    }, []);

    const getData = useCallback((data: any) => data.parent_companies.items, []);

    const modalDestroyParentCompany = useModalTableConfirm({
        message: 'Do you really want to permanently delete this parent company?',
        confirm: (id: number) => Api.parentCompany().destroy(id),
    });

    return (
        <Layout name="Parent companies" breadcrumbs={[{ name: 'Parent companies', current: true }]}>
            {modalDestroyParentCompany.modal}

            <h1>
                Parent companies
                <Button color="brown" text="Add parent company" onClick={() => navigator(LinkHelper.parentCompanies.createParentCompany)} />
            </h1>

            <Table2<any, ParentCompanyResource[]> get={get} getData={getData} getPaginationObject={(data: any) => data.parent_companies.pagination}>
                {{
                    filters: (handleChange) => (
                        <Filter3 onChange={handleChange}>
                            <Filter3.Search />
                        </Filter3>
                    ),
                    items: [
                        (item) => ({
                            content: item.name,
                            name: 'Name',
                            sort: 'name',
                        }),
                    ],
                    actions: [
                        (item) => ({
                            type: 'edit',
                            link: LinkHelper.parentCompanies.editParentCompany(item.id),
                        }),
                        (item) => ({
                            type: 'destroy',
                            onClick: () => modalDestroyParentCompany.action(item.id),
                        }),
                        (item) => ({
                            type: 'open',
                            link: LinkHelper.parentCompanies.detailParentCompany(item.id),
                        }),
                    ],
                }}
            </Table2>
        </Layout>
    );
};
